export default "__VITE_ASSET__DrdJhJNp__"